import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';
import { dimGray, white, PrimaryDark } from '../../../../../../styling/theme';
import scrollBar from '../../../UI/Editor/shared/scrollBar';

export const ErrorMessage = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  text-align: center;

  color: #eb5757;

  justify-content: center;
  padding-top: 8px;
  padding-left: ${(props) => (props.noResults ? '0px' : '48px')};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-top: ${(props) => props.top || '24px'};
  padding-left: 4px;
`;

export const HeadingContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export const Smart = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: rgba(46, 53, 62, 0.87);
  grid-row: 1/1;
  padding-left: 24px;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

export const CloseOuter = styled.div`
  grid-row: 1/1;
  cursor: pointer;
`;

export const Input = styled.input`
  background: ${white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: ${dimGray};
  width: 100%;
  height: 48px;
  padding: 17px 14px;
  outline: none;
  grid-row: 1/1;
  font-family: Arial;
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
`;

export const AdvanceContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 24px;
  margin-bottom: 4px;
`;

export const AdvancedButton = styled.div`
  cursor: pointer;
  margin-left: 10px;
  width: 96px;
  height: 38px;
  background: #e0e0e0;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: rgba(46, 53, 62, 0.87);
  ${(props) => {
    const { submit } = props;
    if (submit) {
      return css`
        &:hover {
          background: ${PrimaryDark};
          color: ${white};
        }
      `;
    }
    return null;
  }};
`;

export const SmallInputContainer = styled.div`
  display: flex;
  padding: 8px 0px 0px 4px;
  padding-left: ${(props) => (props.left ? '0px' : '4px')};
  padding-bottom: ${(props) => (props.bottom ? '8px' : '0px')};
  padding-right: ${(props) => props.right || '0px'};
`;

export const SmallInput1 = styled.input`
  background: ${white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: ${dimGray};
  width: 100%;
  height: 100%;
  padding: 17px 14px;
  outline: none;
  grid-row: 1/1;
  font-family: Arial;
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
`;

export const SmallInput2 = styled.input`
  margin-left: 8px;
  background: ${white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: ${dimGray};
  width: 100%;
  height: 100%;
  padding: 17px 14px;
  outline: none;
  grid-row: 1/1;
  font-family: Arial;
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
`;

export const Authors = styled.div`
  max-height: 300px;
  overflow: overlay;
  margin: 8px 0px;

  padding-left: 4px;
  ${() => {
    const scrollBarStyles = () => scrollBar({ width: '6px', height: '6px' });
    return css`
      ${scrollBarStyles}
    `;
  }};
`;
